import firebase from "firebase";
import { receivedIdToken, logout } from "./actions/login.actions";

function initApp(dispatch) {
    firebase.auth().onAuthStateChanged(
        function(user) {
            if (user) {
                user.getIdToken().then(function(idToken) {
                    dispatch(receivedIdToken({ user, idToken }));
                });
            }
        },
        function(error) {
            console.log("logout error", error);
            dispatch(logout());
        }
    );
}

export default initApp;



// WEBPACK FOOTER //
// ./src/firebaseAuth.js